import ASScroll from '@ashthornton/asscroll'
import { Emitter } from '../events'

import gsap from 'gsap'
import ScrollTrigger from '../vendor/gsap/ScrollTrigger.js'
import { checkScroll, qs } from '../utils'
import store from '../store'

gsap.registerPlugin(ScrollTrigger)

let scroll = null

export default class Smooth {
  constructor() {
    scroll = new ASScroll({
      disableRaf: true,
    })

    store.scroll = scroll

    this.checkScroll = checkScroll()

    this.init()
  }
  
  init() {
    this.styleScrollBar()
    this.setScrollProxy()
    this.addEvents()
  }

  styleScrollBar() {
    if (store.sniffer.isDevice) return 

    let asscrollBar = qs('.asscrollbar')
    Object.assign(asscrollBar.style, {
      width: '6px',
    })        

    let scrollBarDiv = qs('.asscrollbar__handle div')
    Object.assign(scrollBarDiv.style, {
      width: '100%',
      height: '100%',
      borderRadius: '0px',
      opacity: '1',
      background: '#66FDFB',
    })    
  }

  setScrollProxy() {
    ScrollTrigger.defaults({
      scroller: scroll.containerElement
    })

    ScrollTrigger.scrollerProxy(scroll.containerElement, {
      scrollTop(value) {
        return arguments.length ? scroll.currentPos = value : scroll.currentPos;
      },

      getBoundingClientRect() {
          return { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight }
      }
    })    

    scroll.enable()
  }

  addEvents() {
   Emitter.on('tick', scroll.update) 

   scroll.on('update', ScrollTrigger.update)
   scroll.on('scroll', this.checkScroll.run)
   ScrollTrigger.addEventListener('refresh', scroll.resize)
  }
}
